<template>
  <div class="oneLabel">
      <img v-if="jt =='1'" @click="goRouter" src="../../assets/images/cms/jt.png"/>
      <img v-if="jt =='check-service'" @click="goRouter('check-service')" src="../../assets/images/cms/jt.png"/>
      <img v-if="jt =='2'" @click="goRouter" src="../../assets/images/cms/jt2.png"/>
      <img v-if="jt =='3'" @click="goRouter(3)" src="../../assets/images/cms/jt2.png"/>
    {{postName}}
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    postName: String,
    jt:String
  },
  data () {
    return {
      msg:''
    }
  },
  mounted() {
  },
  methods: {
    goRouter(num){
        console.log('@@',num)
        if(num == 3) return this.$router.go(-2)
   /*   if(num == 'check-service'){
        this.$goRoute('check-service')
        return
      }*/
      this.$router.go(-1)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  @import "navBar.less";
</style>



// WEBPACK FOOTER //
// src/cmscomponents/navBar/navBar.vue